import { api } from "../base";
import type { INewOrderSingle } from "@pulse-ui/codegen-v2/generated_ts/order_entry";
import type { IExecutionReport } from "@pulse-ui/codegen-v2/generated_ts/drop_copy";

// Served by digital-algo-gateway, which answers with execution reports.
const algoOrdersEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    sendAlgoNewOrderSingle: build.mutation<IExecutionReport, Partial<INewOrderSingle>>({
      query: (body) => ({
        url: "/api/algo-orders/v1/new_order_single",
        method: "POST",
        body,
      }),
    }),
    // A bare array: one report per order whose status is new or partially_filled.
    getAlgoOpenOrders: build.query<IExecutionReport[], void>({
      query: () => ({ url: "/api/algo-orders/v1/open_orders" }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useSendAlgoNewOrderSingleMutation, useGetAlgoOpenOrdersQuery } =
  algoOrdersEndpoints;
